import { enumToOptions } from '@libs/types/src/common/enum/util';

export enum FolderServiceSocialRequestRejectReasonEnum {
    PROVIDER_DOES_NOT_PROVIDE_SERVICE = 'providerDoesNotProvideService',
    PROVIDER_HAS_NO_AVAILABLE_CAPACITY = 'providerHasNoAvailableCapacity',
    PERSONS_HEALTH_PREVENT_PROVISION = 'personsHealthPreventProvision',
    PERSONS_CONTRACT_WAS_TERMINATED_WITHIN_THE_LAST_SIX_MONTHS = 'personsContractWasTerminatedWithinTheLastSixMonths'
}

export const folderServiceSocialRequestRejectReasonOptions = enumToOptions(FolderServiceSocialRequestRejectReasonEnum, 'person.dashboard.importantInfo.enums.socialRequestRejectReason.');
